import { useState } from "react";
import { Play } from "lucide-react";

// Click-to-load YouTube embed: no third-party script or cookies until the visitor presses play.
export default function VideoEmbed({ id, title, hint }) {
  const [play, setPlay] = useState(false);

  if (play) {
    return (
      <div className="relative aspect-video border border-white/10 bg-black" data-testid="video-embed-player">
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setPlay(true)}
      aria-label={hint}
      data-testid="video-embed-play"
      className="group relative block w-full aspect-video img-frame border border-white/10 text-left"
    >
      <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover img-tone" />
      <div className="absolute inset-0 bg-[#0C0D0F]/40 group-hover:bg-[#0C0D0F]/25 transition-colors" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="w-16 h-16 flex items-center justify-center border border-white/60 bg-[#121316]/70 backdrop-blur-sm text-white group-hover:bg-[#C2A675] group-hover:border-[#C2A675] group-hover:text-[#121316] transition-colors">
          <Play size={22} aria-hidden="true" />
        </span>
      </span>
      <span className="absolute bottom-4 left-4 mono-tag text-[10px] uppercase tracking-[0.2em] text-[#E8E6E1]">{title}</span>
    </button>
  );
}
